var map = {
	"./ATM.svg": 137,
	"./CashTodayUpdateCenterClaro.svg": 5424,
	"./CashTodayUpdateCenterOscuro.svg": 2482,
	"./administration.svg": 377,
	"./analytics.svg": 7533,
	"./analytics_dark.svg": 8028,
	"./bambu.svg": 458,
	"./deposit.svg": 3867,
	"./documents.svg": 1955,
	"./export-icon.svg": 4705,
	"./firmas.svg": 3015,
	"./flujoProvision.png": 5472,
	"./genkin.svg": 7267,
	"./genkin_administration.svg": 8236,
	"./genkin_app.svg": 7883,
	"./header-background.jpg": 9191,
	"./install-authenticator.svg": 7550,
	"./logoProsegurCashFullBlanco.svg": 3719,
	"./logoprosegur.svg": 1659,
	"./logoprosegurBlanco.svg": 8370,
	"./miagencia.svg": 5289,
	"./miagencia_movil.svg": 7009,
	"./myprosegurapp.svg": 2033,
	"./orders.svg": 9112,
	"./orders_dark.svg": 6255,
	"./portal_santander.svg": 1336,
	"./saldosonline.svg": 6768,
	"./soporte.svg": 1193,
	"./transferencias.svg": 9383,
	"./user-management.svg": 6926,
	"./videos.svg": 6139
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3811;